import React from 'react';

const AddButton = props => {
  const { value } = props;
  return (
    <React.Fragment>
      <button
        className="btn--action btn--action-outline form-group__btn"
        type="button"
      >
        {value}
      </button>
    </React.Fragment>
  );
};

export default AddButton;
